import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import {initReactI18next} from 'react-i18next'
import {TRANSLATION_PL} from "./translations/pl/translation";
import {TRANSLATION_EN} from "./translations/en/translation";

// TODO change to dict
export const AvailableLangs = [
    {shortcode: 'pl', name: 'Polski'},
    {shortcode: 'en', name: 'English'},
]

i18n
    .use(LanguageDetector)
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        react: {
            useSuspense: false,
        },
        resources: {
            pl: {
                translation: TRANSLATION_PL
            },
            en: {
                translation: TRANSLATION_EN
            },
            // de: {
            //     translation: TRANSLATION_DE
            // }
        },
        // lng: AvailableLangs[0].shortcode,
        // fallbackLng: AvailableLangs[0].shortcode,
        // interpolation: {
        //   escapeValue: false,
        // },
    });
i18n.changeLanguage('pl');
